import * as yup from 'yup';
import { Formik } from 'formik';
import { Box, InputAdornment } from '@mui/material';
import { SelectField } from '@qrios/frontend-library';

import { naira } from '../../../../../../constants/utils';
import WithFormLayout from '../../../../../common/with-form-layout';
import AmountMaskedInput from '../../../../../common/fields/amount-masked-input';
import { convertAmountToApiFormat } from '../../../../../common/fields/amount-masked-input/utils';
import { amountValidation, paymentMethodValidation } from '../../../../../../constants/validation';

import {
  AddFundsOrderFilters,
  AddFundsToTheWalletOrder,
  ADD_FUNDS_TO_THE_WALLET_FORM,
  PAYMENT_METHODS
} from '../interfaces';
import { AVAILABLE_PAYMENT_METHODS } from '../consts';

const validationSchema = yup.object().shape({
  [ADD_FUNDS_TO_THE_WALLET_FORM.METHOD]: paymentMethodValidation,
  [ADD_FUNDS_TO_THE_WALLET_FORM.AMOUNT]: amountValidation
});

interface Props {
  onClose: () => void;
  onSubmit: ({
    formDataProp,
    orderDataProp
  }: {
    formDataProp: AddFundsOrderFilters;
    orderDataProp: AddFundsToTheWalletOrder;
  }) => void;
  initialValues: AddFundsOrderFilters;
}

const AddingFundsOrderForm = ({ onClose, onSubmit, initialValues }: Props) => (
  <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={values => {
      onSubmit({
        formDataProp: values,
        orderDataProp: {
          [ADD_FUNDS_TO_THE_WALLET_FORM.METHOD]: values.method as PAYMENT_METHODS,
          [ADD_FUNDS_TO_THE_WALLET_FORM.AMOUNT]: convertAmountToApiFormat(values.amount)
        }
      });
    }}
  >
    {({ values, handleChange, handleSubmit, errors, touched, handleBlur }) => (
      <WithFormLayout submitLabel="Go to summary" secondaryLabel="Cancel" onSubmit={handleSubmit} onSecondary={onClose}>
        <Box mb={1}>
          <SelectField
            label="Payment method"
            value={values.method}
            name="method"
            handleBlur={handleBlur}
            handleChange={handleChange}
            placeholder="Select payment method"
            items={AVAILABLE_PAYMENT_METHODS}
            error={errors.method}
            touched={touched.method}
          />
        </Box>
        <Box mb={1}>
          <AmountMaskedInput
            handleChange={handleChange}
            handleBlur={handleBlur}
            label="Amount"
            placeholder="Enter payment amount"
            value={values?.amount}
            startAdornment={<InputAdornment position="start">{naira}</InputAdornment>}
            name="amount"
            error={errors.amount}
            touched={touched.amount}
          />
        </Box>
      </WithFormLayout>
    )}
  </Formik>
);
export default AddingFundsOrderForm;
